<template>
  <router-view :divisions="divisions" :title="title" />
</template>

<script>
import {BlogModule} from '@teemill/modules/blog';

export default {
  name: 'BlogIndex',

  inject: ['app'],

  props: {
    division: {
      type: Number,
    },
  },

  data() {
    return {
      title: '',
      divisions: [],
    };
  },

  created() {
    if (!this.$store.state.blog) {
      this.$store.registerModule('blog', BlogModule);
    }

    if (this.app) {
      switch (this.app.name) {
        case 'atlas':
          this.divisions = [
            2, // Atlas
            12, // Teemill
          ];
          break;
        case 'teemill':
          this.divisions = [
            12, // Teemill
          ];
          break;
        case 'subdomain':
          this.divisions = [this.$store.state.subdomain.division];
      }
    }
  },
};
</script>
